/* eslint-disable @typescript-eslint/ban-types */
import { FormControlLabel, Switch } from '@material-ui/core'
import React, { useState, useEffect } from 'react'
import { useStyles } from './Style'
import { ToggleProps } from './Type'
import { getValue } from './Utils'

const FormToggle: React.FC<ToggleProps> = ({
  label,
  value,
  onChange,
  disabled,
}): React.ReactElement => {
  const classes = useStyles()
  const [switchValue, setswitchValue] = useState(false)

  const onSwitchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setswitchValue(event.target.checked)
    onChange(event.target.checked)
  }

  useEffect(() => {
    setswitchValue(getValue(value))
  }, [value])

  return (
    <>
      <FormControlLabel
        control={<Switch onChange={onSwitchChange} checked={switchValue} disabled={disabled} />}
        label={label}
        className={classes.toggle}
        disabled={disabled}
      />
    </>
  )
}

export default FormToggle
